import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

const Timeline = () => {
  return (
    <div className="timeline">
      <div className="section-title text-center">
        <h2>Этапы выполнения заказа</h2>
        <p>Мы придерживаемся чёткого плана, чтобы гарантировать качественный результат и комфорт для клиента.</p>
      </div>

      <VerticalTimeline>
        <VerticalTimelineElement
          intersectionObserverProps={{
            rootMargin: "0px 0px -40px 0px",
            triggerOnce: true,
          }}
          className="vertical-timeline-element-phone"
          date="10-минутный разговор"
          icon={<div className="fa fa-phone"></div>}
          iconStyle={{}}
        >
          <h3 className="vertical-timeline-element-title">Техническое задание</h3>
          <p>
            Короткий разговор с нашим специалистом, чтобы уточнить детали вашего проекта, задачи и пожелания. На этом этапе формируется предварительное понимание объёма работ и сроков.
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          intersectionObserverProps={{
            rootMargin: "0px 0px -40px 0px",
            triggerOnce: true,
          }}
          className="vertical-timeline-element-car"
          date="Максимальное время ожидания – 3 часа"
          icon={<div className="fa fa-car"></div>}
          iconStyle={{}}
        >
          <h3 className="vertical-timeline-element-title">Выезд на объект</h3>
          <p>Организуем бесплатный выезд специалиста для оценки фронта работ, снятия замеров и уточнения технических деталей.</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          intersectionObserverProps={{
            rootMargin: "0px 0px -40px 0px",
            triggerOnce: true,
          }}
          className="vertical-timeline-element-word"
          date="Завершение возможно в пределах 1 рабочего дня"
          icon={<div className="fa fa-file-word-o"></div>}
          iconStyle={{}}
        >
          <h3 className="vertical-timeline-element-title">Коммерческое предложение</h3>
          <p>Подготовим детальное коммерческое предложение с расчётом стоимости и сроков выполнения работ. Документ отправляется вам на почту или в мессенджер.</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          intersectionObserverProps={{
            rootMargin: "0px 0px -40px 0px",
            triggerOnce: true,
          }}
          className="vertical-timeline-element-pencil"
          date="Продолжительность: максимум 2 рабочих дня"
          icon={<div className="fa fa-pencil"></div>}
          iconStyle={{}}
        >
          <h3 className="vertical-timeline-element-title">Заключение договора</h3>
          <p>После согласования коммерческого предложения мы заключаем договор, организуем закупку материалов и согласовываем график выполнения работ.</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          intersectionObserverProps={{
            rootMargin: "0px 0px -40px 0px",
            triggerOnce: true,
          }}
          className="vertical-timeline-element-check"
/*           contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
          contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }} */
          date="Срок выполнения определяется в зависимости от проекта"
          icon={<div className="fa fa-check"></div>}
          iconStyle={{}}
        >
          <h3 className="vertical-timeline-element-title">Реставрация и завершение проекта</h3>
          <p>Проводим реставрационные работы в согласованные сроки. По завершении подписываем акты выполненных работ и вывозим материалы.</p>
        </VerticalTimelineElement>

      </VerticalTimeline>
    </div>
  );
};

export default Timeline;
